import Typography from "@mui/material/Typography";
import Box from "@mui/system/Box";
import PageHeader from "../components/PageHeader";
import { useContent } from "../app/ContentContext";

function AboutPage() {
  const { aboutPage } = useContent();
  return (
    <Box sx={{ pb: 5 }}>
      <PageHeader title={aboutPage.title} />
      <Box sx={{ maxWidth: "560px", mx: "auto", px: 2 }}>
        {aboutPage.paragraphs.map((paragraph, index) => (
          <Typography
            key={index}
            variant="h6"
            color="text.secondary"
            sx={{
              mb: index < aboutPage.paragraphs.length - 1 ? 2 : 0,
              lineHeight: 1.7,
            }}
          >
            {paragraph}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}

export default AboutPage;
